import { createSelector } from "reselect";
import { getKaMetlhaFuneralCover } from "./index";

export const getBankingDetails = createSelector(
    getKaMetlhaFuneralCover,
    (kaMetlhaFuneralCover) => kaMetlhaFuneralCover.bankingDetails
);
export const getBankingDetailsForm = createSelector(
    getBankingDetails,
    (bankingDetails) => bankingDetails.form
);

const inputFieldLabels = {
    bankName: 'Bank Name',
    branchCode: 'Bank Branch',
    accountHolder: 'Account Holder Name',
    accountNumber: 'Account Number',
    accountType: 'Account Type',
    debitOrderDay: 'Debit Order Deduction day',
    
};
export const getBankingDetailsSummary = createSelector(
    getBankingDetailsForm,
    (bankinDetailsForm) => {
        return Object.keys(bankinDetailsForm).flatMap((item) => {
            return {
                label: inputFieldLabels[item],
                value: bankinDetailsForm[item]?.displayValue ?? '-',
            };
        }).filter(({label})=>label);
    }
);

export const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export const getMonthsIndex = (month)=> monthNames.indexOf(month) 

export const getMontsArray = ()=> {
        const currentDate = new Date();
        const month = currentDate.getMonth();
        const year = currentDate.getFullYear();
        const monthsArray= Array.from({length:2},(_,m)=>({code:(monthNames[month+m]+' '+year),description:(monthNames[month+m]+' '+year)}))
        return monthsArray
}

